import React, { useState, useEffect, useRef } from "react";
import SocialShareButton from "./SocialShareButton";
// import { icons } from "lucide-react";
import { fetchUserAttributes } from "aws-amplify/auth";



const Moments = () => {
  const [cognitoName, setCognitoName] = useState("");
  const [parentProfile, setParentProfile] = useState("false");

  useEffect(() => {
    const getUser = async () => {
      try {
        const attributes = await fetchUserAttributes();
        setCognitoName(attributes.name);
        setParentProfile(attributes['custom:parentProfile'] || "false");
      } catch (error) {
        console.error("Error fetching user attributes:", error);
      }
    };

    getUser();
  }, []);
  
  useEffect(() => {
    const getUser = async () => {
      try {
        const attributes = await fetchUserAttributes();
        if (attributes && attributes.name) {
          setCognitoName(attributes.name);
        }
      } catch (error) {
        console.error("Error fetching user attributes:", error);
      }
    };
    getUser();
  }, []);

const displayName = parentProfile === "true" ? cognitoName : "Your";

  const cards = [
    {
      icon: "./DelTruck.svg",
      title: `College Survival Kit for Maggie is on its way.`,
      // title: `College Survival Kit for ${cognitoName} is on its way.`,
      time: "Today",
      actions: [
        { text: "Message mindyANGIE", icon: "./MindyMssg.png" },
        { text: `Track Order` },
      ],
    },

    {
      icon: "./Stars.svg",
      // title: `${displayName} Birthday is Next Month`,
      title: `Maggie's Birthday is Next Month`,
      subtitle: "Want to plan something special in advance?",
      actions: [
        { text: "Preorder Gifts", icon: "./Offers.png" },
        { text: "Set Reminder", icon: "./MomentBtn2.svg" },
      ],
      time: "yesterday",
    },
    {
      icon: "./book.svg",
      title: `Maggie completed her first week at UCLA. Congratulations!`,
      actions: [{ text: "Public", icon: "./Offers.png" }],
      time: "Sept 22",
    },
    {
      icon: "./DelTruck.svg",
      title: `Maggie's Dorm Makeover Service Successfully Completed 🏡`,
      // title: `${displayName} “Dorm Essential Starter” assistance has been successfully completed.`,
      // subtitle:
      //   "Her comfort package and essentials are all in place 🏡 'That was her first week living on her own – milestone moment 💛' : advance?",
      actions: [
        { text: "Re-live this Moment", icon: "./Share.svg" },
        { text: "Your Order", icon: "./Share.svg" },
      ],
      time: "Sept 20",
    },
    {
      icon: "./Offers.svg",
      // title: `Aunt sent ${displayName} a $25 gift card 🎁 with a note: 'All the best – excited for your new phase!'`,
      title: `Aunt Jean sent Maggie a $25 mindyKNOWS gift card 🎁 with a note: 'All the best – excited for your time at UCLA!'`,
      actions: [{ text: "Send Thank You", icon: "./Share.svg" }],
      time: "Sept 14",
    },
    {
      icon: "./Stars.svg",
      title:
        "Orientation Week begins Monday.  Don’t forget to check the upcoming campus events.",
      // subtitle: "Don’t forget to check the upcoming campus events.",
      time: "Sept 5",
    },
  ];

  // const [activeButton, setActiveButton] = useState(null); // "moments" or "orders"
  const [openOrder, setOpenOrder] = useState(false);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [openRelive, setOpenRelive] = useState(false);
  const popupTriggeredRef = useRef(false); // prevent multiple triggers

  const handleShareClick = () => {
    if (!popupTriggeredRef.current) {
      setShowSharePopup(true);
      popupTriggeredRef.current = true; // only open once
    }
  };

  const handleClosePopup = () => {
    setShowSharePopup(false);
    popupTriggeredRef.current = false; // allow opening again
  };

  return (
    <div
      className="custom-scroll"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flexEnd",
        gap: "36px",
        // alignSelf: "stretch",
        // marginLeft: "0px",
        height: "82vh",
        width: "100%",
        borderRadius: "24px",
        background: "rgba(255, 255, 255, 0.15)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        color: "#fff",
        padding: window.innerWidth >=768 ? "24px" : "16px",
        overflowY: openOrder || openRelive ? "hidden" : "auto",
      }}
    >
      <div style={{ display: !openOrder && !openRelive ? "block" : "none"}}>
        {/* Header */}
        <div
          style={{
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 1,
            alignSelf: "stretch",
            overflow: "hidden",
            color: "var(--Foundation-Foundation, #FFF)",
            textOverflow: "ellipsis",
            fontFamily: "Manrope",
            fontSize: "27px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "100%",
            letterSpacing: "-0.54px",
            // marginBottom: "24px",
          }}
        >
          Moments & Orders
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "36px",
            borderRadius: "16px",
            marginLeft: "10px",
            marginTop: "40px",
            marginBottom: "40px",
            background:
              "linear-gradient(90deg, rgba(126, 179, 171, 0.50) 24.51%, rgba(54, 77, 74, 0.25) 133.73%)",
          }}
        >
          <img
            src="/MomentsMindy2.png"
            alt="Mindy"
            style={{
              width: "100px",
              height: "125px",
              position: "absolute",
              left: "2px",
              top: "58px",
              objectFit: "contain",
            }}
          />
          <div
            style={{
              display: "flex",
              padding: "16px 16px 16px 64px",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              flexDirection: window.innerWidth >=768 ? "" : "column",
              gap: window.innerWidth >=768 ? "8px" : "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "8px",
              }}
            >
              <span
                style={{
                  color: "#F5F3ED",
                  fontFamily: "Manrope",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  lineHeight: "120%" /* 21.6px */,
                  letterSpacing: "-0.36px",
                }}
              >
                “I noticed you've had a busy few weeks!”
              </span>
              <p
                style={{
                  color: "#F5F3ED",
                  fontFamily: "Manrope",
                  fontSize: "15px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: "120%" /* 21.6px */,
                  letterSpacing: "-0.3px",
                }}
              >
                Here's a log so you can relive and share special moments, track orders, and set reminders.
              </p>
            </div>
            <div style={{ display: "flex", gap: "24px" }}>
              
              <button
                style={{
                  display: "flex",
                  padding: "6px 12px",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                  background: "rgba(255, 255, 255, 0.25)",
                  border: "none",
                  borderRadius: "17px",
                  fontFamily: "Manrope",
                  fontSize: window.innerWidth > 768 ? "15px" : '12px',
                  fontStyle: "normal",
                  fontWeight: "700",
                  lineHeight: "120%",
                  letterSpacing: "-0.3px",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                {/* <i
                  style={{
                    width: "24px",
                    height: "24px",
                    aspectRatio: 1 / 1,
                    background: "url('./MomentBtn2.svg')",
                  }}
                /> */}
                Set reminder
              </button>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            alignSelf: "stretch",
            gap: "10px",
          }}
        >
          {cards.map((card, idx) => {
            return (
              <div
                key={idx}
                style={{
                  display: "flex",
                  padding: window.innerWidth> 768 ? "16px 8px" : '16px 0',
                  alignItems: "flex-start",
                  gap: "10px",
                  alignSelf: "stretch",
                  borderBottom: "1px solid rgba(255, 255, 255, 0.20)",
                }}
              >
                {card.icon && (
                  <div
                    style={{
                      display: "flex",
                      width: "60px",
                      height: "60px",
                      padding: "8px",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "10px",
                      borderRadius: "35px",
                      background: "rgba(255, 255, 255, 0.10)",
                    }}
                  >
                    <img
                      src={card.icon}
                      alt="card-icon"
                      style={{
                        width: "46pxx",
                        height: "46px",
                      }}
                    />
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "10px",
                    flex: "1 0 0",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "8px",
                      alignSelf: "stretch",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "space-between",
                        }}
                      >
                        <p
                          style={{
                            color: "var(--Foundation-Foundation, #FFF)",
                            fontFamily: "Manrope",
                            fontSize: "15px",
                            fontStyle: "normal",
                            fontWeight: "700",
                            lineHeight: "120%",
                            letterSpacing: "-0.3px",
                          }}
                        >
                          {card.title}
                        </p>
                        {/* share link removed */}
                        {/* {!card.title.includes("Birthday (Next Month)") && ( */}
                        {!card.title.includes("College Survival Kit for Maggie is on its way") && 
                        !card.title.includes("Maggie's Birthday is Next Month") && 
                        !card.title.includes("Orientation Week begins Monday") && (
                          <SocialShareButton
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              padding: "6px 12px",
                              cursor: "pointer",
                              color: "#FFF",
                              fontFamily: "Manrope",
                              fontSize: "14px",
                              fontWeight: 600,
                              background: "rgba(255,255,255,0.1)",
                              borderRadius: "17px",
                              border: "none",
                            }}
                            title={card.title}
                            url={window.location.href}
                            description={card.description || ""}
                          />
                        )}
                      </div>

                      {card.actions?.some(
                        (action) =>
                          action.text === "Track Order" ||
                          action.text === "Your Order"
                      ) && (
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            cursor: "pointer",
                            flexDirection: window.innerWidth >=768 ? "row" : "column",
                          }}
                          onClick={() => setOpenOrder(true)}
                        >
                          {card.actions?.some(
                            (action) => action.text === "Track Order"
                          ) && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: window.innerWidth > 768 ? "center" : '',
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  backgroundImage: 'url("./clock.svg")',
                                  width: "15px",
                                  height: "12px",
                                  backgroundRepeat: "no-repeat",
                                }}
                              />
                              <span>20 minutes</span>
                            </div>
                          )}
                          <div style={{display:'flex'}}>
                          <div
                            style={{
                              display: "flex",
                              padding: "4px",
                              alignItems: "center",
                              borderRadius: "500px",
                              background: "#7EB3AB",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              style={{ width: "16px", height: "16px" }}
                            >
                              <path
                                opacity="0.5"
                                d="M1.38781 1.8343C1.47941 1.57379 1.76484 1.43685 2.02535 1.52844L2.22628 1.59908C2.6373 1.74357 2.98639 1.86629 3.26112 2.00109C3.55487 2.14522 3.80677 2.32278 3.99622 2.60002C4.18421 2.87512 4.26182 3.17693 4.29764 3.50785C4.31367 3.65598 4.32213 3.81994 4.32659 4.00016H11.4187C12.542 4.00016 13.5532 4.00016 13.8492 4.38488C14.1451 4.76961 14.0294 5.34929 13.798 6.50866L13.4649 8.12514C13.2548 9.1444 13.1497 9.65403 12.7819 9.95376C12.4141 10.2535 11.8938 10.2535 10.8531 10.2535H7.31783C5.45856 10.2535 4.52892 10.2535 3.95132 9.64428C3.37372 9.03506 3.33156 8.38787 3.33156 6.42683L3.33156 4.69238C3.33156 4.19908 3.33088 3.86893 3.30345 3.61546C3.27723 3.37323 3.23076 3.25228 3.17059 3.16423C3.11188 3.07832 3.02277 2.99803 2.82062 2.89884C2.60539 2.79323 2.31288 2.68953 1.86781 2.53306L1.69367 2.47183C1.43316 2.38024 1.29622 2.09481 1.38781 1.8343Z"
                                fill="#F5F7F3"
                              />
                              <path
                                d="M5 12C5.55228 12 6 12.4477 6 13C6 13.5523 5.55228 14 5 14C4.44772 14 4 13.5523 4 13C4 12.4477 4.44772 12 5 12Z"
                                fill="#F5F7F3"
                              />
                              <path
                                d="M11 12C11.5523 12 12 12.4478 12 13C12 13.5523 11.5523 14 11 14C10.4477 14 10 13.5523 10 13C10 12.4478 10.4477 12 11 12Z"
                                fill="#F5F7F3"
                              />
                              <path
                                d="M10.3647 6.34483C10.5551 6.14486 10.5474 5.82837 10.3474 5.63793C10.1475 5.44749 9.83098 5.45521 9.64054 5.65517L8.09784 7.275L7.69801 6.85517C7.50756 6.65521 7.19108 6.64749 6.99111 6.83793C6.79115 7.02837 6.78343 7.34486 6.97387 7.54483L7.73577 8.34483C7.83015 8.44392 7.961 8.5 8.09784 8.5C8.23468 8.5 8.36554 8.44392 8.45991 8.34483L10.3647 6.34483Z"
                                fill="#F5F7F3"
                              />
                            </svg>
                          </div>
                          <p
                            style={{
                              width: "55px",
                              transform: "rotate(-0.438deg)",
                              color: "rgba(255, 255, 255, 0.40)",
                              fontFamily: "Manrope",
                              fontSize: "15px",
                              fontStyle: "normal",
                              fontWeight: "700",
                              lineHeight: "120%" /* 18px */,
                              letterSpacing: "-0.3px",
                            }}
                          >
                            ---------
                          </p>
                          <div
                            style={{
                              display: "flex",
                              padding: "4px",
                              alignItems: "center",
                              borderRadius: "500px",
                              background: "#7EB3AB",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="17"
                              height="16"
                              viewBox="0 0 17 16"
                              fill="none"
                              style={{ width: "16px", height: "16px" }}
                            >
                              <path
                                d="M5.75028 13.7456C6.92069 14.3598 7.5059 14.6669 8.13542 14.6669V8.00024L1.89409 4.71533C1.88491 4.7301 1.87588 4.74501 1.86701 4.76007C1.46875 5.4364 1.46875 6.27802 1.46875 7.96125V8.03923C1.46875 9.72246 1.46875 10.5641 1.86701 11.2404C2.26528 11.9167 2.9825 12.2931 4.41695 13.0459L5.75028 13.7456Z"
                                fill="white"
                                fill-opacity="0.6"
                              />
                              <path
                                opacity="0.7"
                                d="M11.8504 2.95451L10.5171 2.25481C9.34667 1.6406 8.76146 1.3335 8.13195 1.3335C7.50243 1.3335 6.91723 1.6406 5.74681 2.25481L4.41348 2.95451C3.01097 3.69051 2.2941 4.06671 1.89062 4.71526L8.13195 8.00016L14.3733 4.71526C13.9698 4.06671 13.2529 3.69051 11.8504 2.95451Z"
                                fill="white"
                              />
                              <path
                                opacity="0.5"
                                d="M14.4012 4.76007C14.3923 4.74501 14.3833 4.7301 14.3741 4.71533L8.13281 8.00024V14.6669C8.76233 14.6669 9.34754 14.3598 10.518 13.7456L11.8513 13.0459C13.2857 12.2931 14.003 11.9167 14.4012 11.2404C14.7995 10.5641 14.7995 9.72246 14.7995 8.03923V7.96125C14.7995 6.27802 14.7995 5.4364 14.4012 4.76007Z"
                                fill="white"
                              />
                              <path
                                d="M4.34707 2.98937C4.36896 2.97788 4.39102 2.96631 4.41325 2.95464L5.40894 2.43213L11.4761 5.76908L14.1586 4.42784C14.2504 4.53179 14.3302 4.64133 14.4001 4.76012C14.4998 4.92947 14.5746 5.10917 14.6306 5.30986L11.9651 6.64265V8.66696C11.9651 8.94311 11.7412 9.16696 11.4651 9.16696C11.1889 9.16696 10.9651 8.94311 10.9651 8.66696V7.14265L8.63172 8.30931V14.603C8.46045 14.6456 8.29762 14.667 8.13172 14.667C7.96582 14.667 7.80299 14.6456 7.63172 14.603V8.30931L1.63281 5.30986C1.68885 5.10918 1.7636 4.92947 1.86332 4.76012C1.93327 4.64133 2.01306 4.53179 2.10485 4.42784L8.13172 7.44128L10.3892 6.31254L4.34707 2.98937Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                          <p
                            style={{
                              width: "55px",
                              transform: "rotate(-0.438deg)",
                              color: "rgba(255, 255, 255, 0.40)",
                              fontFamily: "Manrope",
                              fontSize: "15px",
                              fontStyle: "normal",
                              fontWeight: "700",
                              lineHeight: "120%" /* 18px */,
                              letterSpacing: "-0.3px",
                            }}
                          >
                            ---------
                          </p>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              opacity="0.5"
                              d="M20.5355 20.5355C22 19.0711 22 16.714 22 12C22 7.28595 22 4.92893 20.5355 3.46447C19.0711 2 16.714 2 12 2C7.28595 2 4.92893 2 3.46447 3.46447C2 4.92893 2 7.28595 2 12C2 16.714 2 19.0711 3.46447 20.5355C4.92893 22 7.28595 22 12 22C16.714 22 19.0711 22 20.5355 20.5355Z"
                              fill="#5C99B2"
                            />
                            <path
                              d="M17.4545 6.90347C17.784 7.1545 17.8476 7.62509 17.5966 7.95457L10.7394 16.9546C10.6029 17.1338 10.393 17.2421 10.1678 17.2496C9.94267 17.2571 9.72605 17.163 9.57788 16.9933L6.43502 13.3933C6.16261 13.0812 6.19473 12.6075 6.50677 12.3351C6.8188 12.0626 7.29259 12.0948 7.565 12.4068L10.1034 15.3144L16.4034 7.04551C16.6545 6.71603 17.1251 6.65243 17.4545 6.90347Z"
                              fill="#ffffff42"
                            />
                          </svg></div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      padding: "6px 0",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    {card.subtitle && (
                      <p
                        style={{
                          color: "var(--Foundation, #F5F3ED)",
                          fontFamily: "Manrope",
                          fontSize: "13px",
                          fontStyle: "normal",
                          fontWeight: "400",
                          lineHeight: "120%" /* 18px */,
                          letterSpacing: "-0.3px",
                        }}
                      >
                        {card.subtitle}
                      </p>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      alignItems: window.innerWidth >=768 ? "center" : "",
                      justifyContent: "space-between",
                      flexDirection: window.innerWidth >=768 ? "" : "column",
                      gap: window.innerWidth >=768 ? "" : '16px',
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "flex-start",
                        gap: window.innerWidth >=768 ? "96px" : '16px',
                      }}
                    >
                      {card.actions?.map((action, aIdx) => (
                        <div
                          key={aIdx}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            cursor: "pointer",
                            background: "rgba(255, 255, 255, 0.25)",
                            border: "none",
                            borderRadius: "17px",
                            fontFamily: "Manrope",
                            fontStyle: "normal",
                            fontWeight: "700",
                            lineHeight: "120%" /* 18px */,
                            letterSpacing: "-0.3px",
                            color: "#fff",
                            padding: window.innerWidth > 768 ? "6px 12px" : '4px 8px',
                          }}
                          onClick={() => {
                            // if (action.text === "Track Order" || action.text === "Your Order")
                            //   setOpenOrder(true);
                            // keep other actions working as before
                            if (
                              action.text === "Track Order" ||
                              action.text === "Your Order"
                            ) {
                              setOpenOrder(true);
                            } else if (action.text === "Re-live this Moment") {
                              setOpenRelive(true);
                            }
                          }}
                        >
                          {/* <img
                        src={action.icon}
                        alt="action-icon"
                        style={{ width: "20px", height: "20px" }}
                      /> */}

                          {action.text === "Share" ? (
                            <SocialShareButton
                              url={window.location.href}
                              title={card.title}
                              description={card.subtitle}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                                color: "#fff",
                                padding: "4px 10px",
                                fontFamily: "Manrope",
                                fontSize: "14px",
                                fontWeight: "600",
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                marginTop: "4px",
                                background: "transparent", // default background
                              }}
                              onMouseEnter={
                                (e) =>
                                  (e.currentTarget.style.background =
                                    "transparent") // keep it transparent on hover
                              }
                              onMouseLeave={
                                (e) =>
                                  (e.currentTarget.style.background =
                                    "transparent") // keep it transparent on leave
                              }
                            >
                              Share
                            </SocialShareButton>
                          ) : (
                            <span
                              style={{
                                color: "#F5F3ED",
                                fontFamily: "Manrope",
                                fontSize: window.innerWidth > 768 ? "15px" : '12px',
                                fontWeight: "700",
                                lineHeight: "120%",
                              }}
                            >
                              {action.text}
                            </span>
                          )}
                          {action.text === "Public" && (
                            <div style={{ display: "flex", gap: "5px" }}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="36"
                                height="18"
                                viewBox="0 0 36 18"
                                fill="none"
                              >
                                <rect
                                  width="36"
                                  height="18"
                                  rx="9"
                                  fill="white"
                                  fill-opacity="0.2"
                                />
                                <circle
                                  cx="9.00781"
                                  cy="9.00662"
                                  r="7.9994"
                                  transform="rotate(0.0517072 9.00781 9.00662)"
                                  fill="#FFFBFA"
                                />
                              </svg>
                              <p>Private</p>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                    <div>
                      <p
                        style={{
                          color: "#F5F3ED",
                          fontFamily: "Manrope",
                          fontSize: "15px",
                          fontWeight: "500",
                          lineHeight: "120%",
                          width: "max-content",
                        }}
                      >
                        {card.time}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* CHANGE 5: Added new Re-live This Moment Popup - Complete popup component with memories, photos, and actions */}
      {openRelive && (
        <div
          style={{
            display: "flex",
            // width: "100%",
            height: "100%",
            padding: "24px",
            // flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            position: "absolute",
            right: 0,
            left: 0,
            top: 0,
            borderRadius: "20px",
            background: "rgba(255, 255, 255, 0.10)",
            boxShadow: "0 10px 25px 0 rgba(0, 10, 25, 0.08)",
            backdropFilter: "blur(20px)",
          }}
        >
          <div style={{display: 'flex', alignItems: 'flex-end', flexDirection: 'column', height: '100%', gap: '8px'}}>
          <div
            style={{
              display: "flex",
              // alignSelf: "flex-end",
              cursor: "pointer",
            }}
            onClick={() => {
              setOpenRelive(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M15.7128 16.773L7.22748 8.28777C6.93757 7.99785 6.93757 7.51702 7.22748 7.22711C7.5174 6.93719 7.99823 6.93719 8.28814 7.22711L16.7734 15.7124C17.0633 16.0023 17.0633 16.4831 16.7734 16.773C16.4835 17.063 16.0027 17.063 15.7128 16.773Z"
                fill="white"
              />
              <path
                d="M7.22658 16.773C6.93666 16.4831 6.93666 16.0023 7.22658 15.7124L15.7119 7.22711C16.0018 6.93719 16.4826 6.93719 16.7725 7.22711C17.0624 7.51702 17.0624 7.99785 16.7725 8.28777L8.28724 16.773C7.99732 17.063 7.51649 17.063 7.22658 16.773Z"
                fill="white"
              />
            </svg>
          </div>
          <div
            className="custom-scroll"
            style={{
              display: "flex",
              // width: "100%",
              width: "698px",
              padding: "24px",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "24px",
              flex: "1 0 0",
              borderRadius: "20px",
              background: "rgba(255, 255, 255, 0.20)",
              overflowY: "auto",
            }}
          >
            <div
              className=""
              style={{
                color: "#FFF",

                fontFamily: "Manrope",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "28px",
                letterSpacing: "0.09px",
              }}
            >
              Orders
            </div>
            {/* Header Section */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <div
                style={{
                  width: "41px",
                  height: "41px",
                  // borderRadius: "50%",
                  // background: "rgba(255, 255, 255, 0.2)",
                  display: "flex",
                  // alignItems: "start",
                  // justifyContent: "center",
                }}
              >
                <img src="/reliveicon1.svg" alt="" />
              </div>
              <div className="">
                <div>
                  <p
                    style={{
                      color: "#FFF",
                      fontFamily: "Manrope",
                      fontSize: "15px",
                      fontWeight: "700",
                    }}
                  >
                    Dorm Makeover Service
                  </p>
                  <p
                    style={{
                      color: "#FFF",
                      fontFamily: "Manrope",
                      fontSize: "15px",
                      fontWeight: "400",
                    }}
                  >
                    Check out Maggie's new digs!
                  </p>
                  <p
                    style={{
                      color: "#FFF",
                      fontFamily: "Manrope",
                      fontSize: "15px",
                      fontWeight: "700",
                    }}
                  >
                    Completed Sept. 20
                  </p>
                </div>
              </div>
            </div>

            <p
              style={{
                color: "#FFF",
                fontFamily: "Manrope",
                fontSize: "15px",
                fontWeight: "700",
              }}
            ></p>

            {/* Photo Section */}
            <div
              style={{
                width: "100%",
                maxWidth: "400px",
                borderRadius: "16px",
                // overflow: "hidden",
                height: "300px",
                background: "rgba(255, 255, 255, 0.20)",
                border: "1px solid #EBEBEB",
                objectFit: "cover",
              }}
            >
              <img
                src="/Relive3.png" 
                alt="Delivery moment"
                style={{
                  width: "100%", 
                  height: "100%", 
                  padding: "16px",

                  // width: "273px",
                  // height: "364px",

                  // display: "block",
                  // objectFit: "cover",
                }}
              />
            </div>

            {/* Share Button */}
            
            <SocialShareButton
              section="relive"
              card={{ title: "Delivery Moment", image: "/Relive2.png" }}
            />


            {/* Feedback Section */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                width: "100%",
              }}
            >
              <p
                style={{
                  color: "#FFF",
                  fontFamily: "Manrope",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                How do you feel about mindyANGIE's service?
              </p>
              <div
                style={{
                  display: "flex",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    // padding: "16px",
                    borderRadius: "12px",
                    background: "rgba(255, 255, 255, 0.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background =
                      "rgba(255, 255, 255, 0.25)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background =
                      "rgba(255, 255, 255, 0.15)";
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
                  </svg>
                </div>
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    background: "rgba(255, 255, 255, 0.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background =
                      "rgba(255, 255, 255, 0.25)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background =
                      "rgba(255, 255, 255, 0.15)";
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          </div>
          {/* CHANGE 6: Close button for Re-live popup */}
          
        </div>
      )}

      {/* Your existing openOrder popup code continues here... */}

      {openOrder && (
        // Order Page
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "100%",
            padding: window.innerWidth > 768 ? "100px" : '100px 10px',
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            position: "absolute",
            right: 0,
            left: 0,
            top: 0,
            borderRadius: "20px",
            background: "rgba(255, 255, 255, 0.10)",
            boxShadow: "0 10px 25px 0 rgba(0, 10, 25, 0.08)",
            backdropFilter: "blur(20px)",
          }}
        >
          <div
            style={{ alignSelf: "flex-end", cursor: "pointer" }}
            onClick={() => {
              setOpenOrder(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M15.7128 16.773L7.22748 8.28777C6.93757 7.99785 6.93757 7.51702 7.22748 7.22711C7.5174 6.93719 7.99823 6.93719 8.28814 7.22711L16.7734 15.7124C17.0633 16.0023 17.0633 16.4831 16.7734 16.773C16.4835 17.063 16.0027 17.063 15.7128 16.773Z"
                fill="white"
              />
              <path
                d="M7.22658 16.773C6.93666 16.4831 6.93666 16.0023 7.22658 15.7124L15.7119 7.22711C16.0018 6.93719 16.4826 6.93719 16.7725 7.22711C17.0624 7.51702 17.0624 7.99785 16.7725 8.28777L8.28724 16.773C7.99732 17.063 7.51649 17.063 7.22658 16.773Z"
                fill="white"
              />
            </svg>
          </div>
          <div
            className="custom-scroll"
            style={{
              display: "flex",
              width: "100%",
              padding: "24px",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "24px",
              flex: 1,
              borderRadius: "20px",
              background: "rgba(255, 255, 255, 0.20)",
              overflowY: "auto",
            }}
          >
            <p
              style={{
                color: "var(--Foundation-Foundation, #FFF)",
                fontFamily: "Manrope",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "28px" /* 155.556% */,
                letterSpacing: "0.09px",
              }}
            >
              Orders
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "8px",
              }}
            >
              <p
                style={{
                  width: "55px",
                  height: "30px",
                  transform: "rotate(90deg)",
                  color: "#FFF",
                  fontFamily: "Manrope",
                  fontSize: "15px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  lineHeight: "120%" /* 18px */,
                  letterSpacing: "-0.3px",
                  marginLeft: "-10px",
                }}
              >
                -------
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  alignSelf: "stretch",
                }}
              >
                <img
                  src="./Cart Check.svg"
                  alt=""
                  style={{ width: "40px", height: "40px", aspectRatio: 1 / 1 }}
                />
                <span
                  style={{
                    color: "#FFF",
                    fontFamily: "Manrope",
                    fontSize: "15px",
                    fontStyle: "normal",
                    fontWeight: "700",
                    lineHeight: "120%" /* 18px */,
                    letterSpacing: "-0.3px",
                  }}
                >
                  Your Order is Placed
                </span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                alignSelf: "stretch",
              }}
            >
              <p
                style={{
                  width: window.innerWidth > 768 ?  "124px" : '158px',
                  height: "30px",
                  transform: "rotate(90deg)",
                  color: "rgba(255, 255, 255, 0.40)",
                  fontFamily: "Manrope",
                  fontSize: "15px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  lineHeight: "120%" /* 18px */,
                  letterSpacing: "-0.3px",
                  marginLeft: "-46px",
                }}
              >
                --------------------
              </p>
              <div
                style={{
                  display: "flex",
                  width: "320px",
                  padding: "16px",
                  flexDirection: "column",
                  // alignItems: "flex-start",
                  gap: "16px",
                  borderRadius: "16px",
                  border: "1px solid var(--Grey-grey-100, #EBEBEB)",
                  background: "rgba(255, 255, 255, 0.20)",
                  marginLeft: "-35px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    alignSelf: "stretch",
                  }}
                >
                  <button
                    style={{
                      color: "var(--Yellow-yellow-600, #E0AF02)",
                      padding: "4px 10px",
                      borderRadius: "100px",
                      border: "1px solid var(--Yellow-yellow-100, #FCEBB1)",
                      background: "var(--Yellow-yellow-50, #FEF9E6)",
                      fontFamily: "Manrope",
                      fontSize: "13px",
                      fontStyle: "normal",
                      fontWeight: "400",
                      lineHeight: "120%" /* 15.6px */,
                      letterSpacing: "-0.26px",
                      cursor: "pointer",
                    }}
                  >
                    Celebrate
                  </button>
                  <img
                    src="./Menu Dots.svg"
                    alt="menu-dots"
                    style={{ width: "18px", height: "18px" }}
                  />
                </div>
                <p
                  style={{
                    color: "var(--Foundation-Foundation, #FFF)",
                    fontFamily: "Manrope",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "20px" /* 142.857% */,
                    letterSpacing: "0.07px",
                  }}
                >
                  Birthday Treat Box x1
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img src="./Calendar.svg" alt="calendar" />
                  <span>21 Oct 2022</span>
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                alignSelf: "stretch",
              }}
            >
              <img
                src="./Order Box.svg"
                alt=""
                style={{
                  width: "40px",
                  height: "40px",
                  aspectRatio: 1 / 1,
                  opacity: "0.6",
                }}
              />
              <span
                style={{
                  color: "#FFF",
                  fontFamily: "Manrope",
                  fontSize: "15px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  lineHeight: "120%" /* 18px */,
                  letterSpacing: "-0.3px",
                  opacity: "0.6",
                }}
              >
                Your order is on way
              </span>
            </div>
            <p
              style={{
                width: "55px",
                height: "30px",
                transform: "rotate(90deg)",
                color: "#FFF",
                fontFamily: "Manrope",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "120%" /* 18px */,
                letterSpacing: "-0.3px",
                opacity: 0.6,
                marginLeft: "-10px",
              }}
            >
              ---------
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                alignSelf: "stretch",
              }}
            >
              <img
                src="./Order Box.svg"
                alt=""
                style={{
                  width: "40px",
                  height: "40px",
                  aspectRatio: 1 / 1,
                  opacity: "0.6",
                }}
              />
              <span
                style={{
                  color: "#FFF",
                  fontFamily: "Manrope",
                  fontSize: "15px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  lineHeight: "120%" /* 18px */,
                  letterSpacing: "-0.3px",
                  opacity: "0.6",
                }}
              >
                Package Delivered
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Moments;
